<template>
    <div id="voidModal" ref="voidModal" class="modal fade fxModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered laptop:!max-w-[60%] largeDesktop:!max-w-[25%]">
            <div class="modal-content">
                <div class="modal-body !p-[25px] flex flex-col gap-[20px]">
                    <FxModalHeader title="Void" :dismiss="false" @close="hide()" />
                    <div class="flex flex-col gap-[20px] px-[10px] tablet:px-0">
                        <div class="flex flex-col gap-[8px]">
                            <label class="!m-0 text-[16px] font-roboto font-normal text-[#333]">Enter Reason</label>
                            <!-- v-if="selectedReason != null && selectedReason.reason == 'Other'" -->
                            <textarea id="addReasonsTextarea" v-model="otherReason" rows="3"
                                class="font-roboto text-[14px]  rounded-[5px] p-[5px] resize-none !outline-none border-[1px] border-[#efefef] text-[#333] placeholder:text-[#999]"
                                placeholder="Enter reason here." />
                        </div>
                        <div class="flex items-center justify-center gap-[10px]">
                            <button :disabled="otherReason.length <= 0" @click="sendSharedURL()" type="button"
                                class="fxBtnPrimary disabled:!bg-[#CCCCCC] disabled:!border-[#CCCCCC] disabled:cursor-not-allowed">
                                Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: { FxModalHeader },
    props: ["invoiceDetail"],

    data() {
        return {
            modal: null,
            loading: true,
            selectedReason: null,
            otherReason: "",
            invoiceId: null,
        };
    },

    computed: {
        ...mapGetters([
            "sendVoidReason"
        ]),
    },

    watch: {
        sendVoidReason: function () {
            // if (success) {
                this.hide();
                this.$emit('success');
            // }
        }

    },

    mounted() {

    },

    methods: {
        ...mapActions([
            "sendVoidReasonData"
        ]),

        show(value) {
            this.invoiceId = value;
            if (!this.modal) {
                this.modal = new Modal(this.$refs.voidModal, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            this.otherReason = "",
                this?.modal?.show();
        },

        hide() {
            this.modal?.hide();
        },

        async sendSharedURL() {
            const payload = {
                id: this.invoiceId,
                reason: this.otherReason,
            };
            this.sendVoidReasonData(payload);
        }
    }
}
</script>